import React from 'react';
import { SectionSkeleton, SECTION_SKELETON_VARIANTS } from './SectionSkeleton';

/**
 * CardGridSkeleton — backward-compatible wrapper.
 *
 * @deprecated Use `<SectionSkeleton variant="cardGrid" />` instead.
 * @param {boolean} isMobile - viewport flag [Optional]
 * @param {string} title - section title [Optional]
 */
export const CardGridSkeleton = ({ isMobile, title }) => (
  <SectionSkeleton
    variant={SECTION_SKELETON_VARIANTS.cardGrid}
    isMobile={isMobile}
    title={title}
  />
);
